import '../scss/_slider.scss'
import $ from 'jquery'
import MediaQueries from "media-queries"

import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"
import "slick-carousel/slick/slick.js"

export class DkSlider{
   constructor(elem){
      const $this = $(elem),
            autoHeight = $this.data("auto-height");

      this.elem = elem;
      this.autoHeight = autoHeight;
      this.sliderInstance;

      this.init_slider();
      this.init_events();
   }

   init_slider(){

      this.sliderInstance = $(".slides-container", this.elem).slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: this.autoHeight,
        mobileFirst: true,
        responsive: [
           {
              breakpoint: MediaQueries.smallBreakpoint,
              settings: {
                   arrows: false
              }
           },
           {
              breakpoint: MediaQueries.mediumBreakpoint,
              settings: {
                   arrows: true
              }
           }
       ]

      });


      $(this.sliderInstance).trigger('resize');
   }

   init_events(){
      this.sliderInstance.on('resize.slider', $(this.elem), (e) => {
         this.sliderInstance.slick('setPosition');
      });
   }

}

export default class DkSlidersManager{
   constructor(){
      this.sliders = $('.slider').toArray().reduce( (a, e ) => (
        { [e.id] : new DkSlider(e),
          ...a
         }
      ), {});
   }

}